module.exports = __webpack_public_path__ + "static/img/obudowa_plytki2.6283944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/obudowa_plytki2.png
// module id = EqqP
// module chunks = 1